<template>
  <div>
    <div class="font py-5 bg-color h-100v" v-if='signupMode ==false'>
      <b-container>
        <b-row>
          <b-col cols='5' class='mx-auto'>
            <b-card class='org-session text-center'>
              <h4 class="mb-4 mt-4">ログイン</h4>

              <validation-observer class="form bg-white" ref="obs" >
                <b-row class=" mx-2 mt-2">
                  <b-col class=" mx-auto px-20 text-left">
                    <validation-provider name="email" rules="required">
                      <div slot-scope="mail_adress">
                        <small>メールアドレス</small>
                        <b-input-group class=" session-input" :class='{"error-input": mail_adress.failed}'>
                          <template #prepend>
                            <b-input-group-text class='session-icon-input'><b-icon icon="envelope-fill"></b-icon></b-input-group-text>
                          </template>
                          <b-form-input placeholder="Email" v-model="email"></b-form-input>
                        </b-input-group>
                        <p v-if="mail_adress.failed" class="error">{{ mail_adress.errors[0] }}</p>
                      </div>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class=" mx-2 mt-2">
                  <b-col class=" mx-auto px-20 text-left">
                    <validation-provider name="password" rules="required|password">
                      <div>
                        <small>パスワード</small>
                        <b-input-group class=" session-input-side" :class='{"error-input": isMiss}'>
                          <template #prepend>
                            <b-input-group-text class='session-icon-input'><b-icon icon="lock-fill"></b-icon></b-input-group-text>
                          </template>
                          <b-form-input :type="inputType" placeholder="Password" v-model="password"></b-form-input>
                          <template #append>
                            <b-input-group-text class='session-icon-input-append'><b-icon :icon="icon" @click="switchPassword"></b-icon></b-input-group-text>
                          </template>
                        </b-input-group>
                      </div>
                    </validation-provider>
                    <p class="text-center mt-3 mb-0 text-error" v-if='isMiss'><b>{{$t("message.missPassword")}}</b></p>
                  </b-col>
                </b-row>
              </validation-observer>

              <b-row class=" pt-1">
                <b-col cols='11' class="mx-auto pl-3 text-left">
                  <b-button  class="forgot px-0">
                    <u>{{$t("message.forgot_password")}}</u>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols='10' class="mx-auto">
                  <b-button  class="login py-2 px-4 width100" @click="login" > {{$t("message.login")}} </b-button>
                </b-col>
              </b-row>

              <p class="my-3">AELUを初めて利用する場合は、<br>アカウントを作成しましょう</p>

              <b-button @click='signupMode = true' class="forgot px-0">
                <h5>新規登録</h5>
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-else>
      <signup @changMode='changMode()'></signup>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver} from "vee-validate";
import Signup from "@/components/Agency/session/Signup";
import axios from 'axios';
import { Auth } from "aws-amplify";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Signup
  },
  data() {
    return {
      isChecked: true,
      inputType: 'password',
      email: "",
      password: "",
      icon: "eye-fill",
      isMiss: false,
      signupMode: false
    }
  },
  mounted(){
    this.$store.commit('setLoading', false)
  },
  methods: {
    changMode(){
      this.signupMode = false
    },
    switchPassword(){
      if (this.isChecked) {
        this.isChecked = false
        this.inputType = "text"
        this.icon = "eye-slash-fill"
      } else {
        this.isChecked = true
        this.inputType = "password"
        this.icon = "eye-fill"
      }
    },
    authGoogle(){
      Auth.federatedSignIn({provider: 'Google'})
    },
    authFacebook(){
      Auth.federatedSignIn({provider: 'Facebook'})
    },
    login(){
      this.$refs.obs.validate().then(value =>{
        if(value){
          Auth.signIn(this.email, this.password)
            .then(response =>{
              console.log('tihsdfsfdsdf',response)
              localStorage.idToken = response.signInUserSession.accessToken.jwtToken
              this.$store.commit('agencystaff/setStaffOuth', response)
              axios
              .get(process.env.VUE_APP_API + "/api/agcy/agency_staffs/callback", {headers: {'Authorization': 'Bearer ' + response.signInUserSession.accessToken.jwtToken}})
              .then(result => {
                console.log(result)
                var r = result.data.path == undefined? "" : result.data.path
                console.log(r)
                if(r == "./startup") {
                  console.log('enter')
                  this.$router.replace("/agency/startup")
                }
                this.$router.replace("/agency/mypage")
              }).catch(error => {
                console.log('this is error', error)
              })
            })
            .catch(error =>{
              console.log(error)
              if(error.code == "UserNotConfirmedException"){
                var locate = this.$i18n.locale
                this.$swal.fire({
                  icon: 'error',
                  title: this.$i18n.messages[locate]['message']["not_confirm"],
                  text: this.$i18n.messages[locate]['message']["move_confirm"] ,
                  confirmButtonText: this.$i18n.messages[locate]['message']['resendCode']
                }).then(()=>{
                  Auth.resendSignUp(this.email)
                    .then(() =>{
                      this.showConfirm()
                    }).catch(error => {
                      console.log('this is error', error)
                    })
                })
              }else{
                if(error.code == 'UserNotFoundException' || error.code == "NotAuthorizedException"){
                  this.isMiss = true
                }

              }
            })

        }
      })
    }
  }
}
</script>
<style type="scss" scoped>
.header{
  background-color: #000054;
  height: 65px;
}

.icon{
  height: 35px !important;
}

.bg-color{
  background-color: #f3f3f3;
}

.org-session{
  border-radius: 1.5rem;
}

.forgot{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 0.8rem;

  &:hover {
    box-shadow: none !important;
  }
}
.text-orange{
  color: #F29147 !important;
}
</style>
